// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_2cZJ7M"};